type RegionSection = {
	label: string;
	items: {
		label: string;
		id: string;
	}[];
};

export const regionList: RegionSection[] = [
	{
		items: [
			{
				id: "9ca5bb49-25a8-470d-bc8e-cd7492f03d4b",
				label: "Eastern Canada",
			},
			{
				id: "41d69839-515c-4b80-b8c6-c08d5e91b504",
				label: "Mid America",
			},
			{
				id: "c3370c48-07f5-4b5f-92cd-05390e70c2bf",
				label: "Mid Atlantic",
			},
			{
				id: "6c75bcc1-593a-4088-ae8d-9f1dcc0e0005",
				label: "New England",
			},
			{
				id: "8766f264-f61b-4314-9418-d7439f1e3611",
				label: "Southern U.S.",
			},
			{
				id: "0015eadf-98b7-472c-b5a9-18ddfe0e3b38",
				label: "Western Canada",
			},
			{
				id: "14555297-548b-4f1f-be0a-2dc96a6a3904",
				label: "Western U.S.",
			},
			{
				id: "0f9a8461-96d5-4317-9083-ad265f51855f",
				label: "Irish Dance Teachers Association of North America",
			},
		],
		label: "North America",
	},
	{
		items: [
			{
				id: "46c08df7-d194-4641-916a-02746a88d219",
				label: "Connaght",
			},
			{
				id: "10e7d35a-2f55-4ff6-8b32-bc615a9e5b74",
				label: "Leinster",
			},
			{
				id: "13081257-6def-4903-83d3-69a32bdc4763",
				label: "Midlands England",
			},
			{
				id: "c6a4bd64-58f4-467c-a392-8ca329b72fe5",
				label: "Munster",
			},
			{
				id: "1b41e8ed-eac0-4fb2-b883-a9ed0be190e5",
				label: "North-East England",
			},
			{
				id: "ba3fa5a3-6bca-4d1d-b72e-097d3f1e1ace",
				label: "North-West England",
			},
			{
				id: "1a8df435-e03a-41a0-aad4-a2767b253b84",
				label: "Scotland",
			},
			{
				id: "e81d3a9a-6572-4e87-8d71-921149c4eb94",
				label: "Southern England",
			},
			{
				id: "e17eb93c-a103-40bc-9cfc-d220ad5dfe8e",
				label: "Ulster",
			},
		],
		label: "British Isles",
	},
	{
		items: [
			{
				id: "630a4a4d-fbc0-41f6-9863-29efedeab6eb",
				label: "Capital Territory",
			},
			{
				id: "f56fcdba-1530-4871-9005-7ca56cb9e424",
				label: "New South Wales",
			},
			{
				id: "ecc240bc-fd95-47dd-a7db-feded414149b",
				label: "Queensland",
			},
			{
				id: "2df80ed7-ac8a-43e2-b63e-59d0f54a61e3",
				label: "Southern",
			},
			{
				id: "716112a0-04f1-439e-8a4a-1a1f6cd9eba2",
				label: "Victoria / Tasmania",
			},
			{
				id: "3551e4af-ca99-49df-8485-1d3b12351e7a",
				label: "Western",
			},
		],
		label: "Australia",
	},
	{
		items: [
			{
				id: "7237c22b-762c-413f-a688-ed364953a1ab",
				label: "An Coimisiún Le Rincí Gaelacha",
			},
			{
				id: "4a99b626-a051-4ffe-a082-6a3d514f4480",
				label: "New Zealand",
			},
			{
				id: "21bd3c36-b0b9-408f-9b15-25f5e2283d99",
				label: "Regional Council of Continental Europe and Asia",
			},
			{
				id: "4918b3cf-a42e-425a-98f5-f9546e553158",
				label: "South Africa",
			},
		],
		label: "Other Areas",
	},
];
